export const appVersion = process.env.REACT_APP_VERSION;

const REACT_APP_EN = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'dev'

const config = require('./' + REACT_APP_EN)

export default config.default
